
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundles",
      function () {
        return require("private-next-pages/bundles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundles"])
      });
    }
  